import { render, staticRenderFns } from "./EditQuotation.vue?vue&type=template&id=18db0656&scoped=true&"
import script from "./EditQuotation.vue?vue&type=script&lang=js&"
export * from "./EditQuotation.vue?vue&type=script&lang=js&"
import style0 from "./EditQuotation.vue?vue&type=style&index=0&id=18db0656&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18db0656",
  null
  
)

export default component.exports